export default "__VITE_ASSET__C6M1LuWD__"